export const thyroidModuleOverview = [
  {
    id: "anatomy",
    title: "Thyroid Anatomy",
    description: "Learn the structure of the thyroid gland",
    icon: "❤️",
    customImage: "module-thyroid-anatomy.png",
    gradient: "from-violet-400 via-indigo-50 to-purple-300 border-violet-500",
  },
  {
    id: "anatomy2",
    title: "Thyroid Anatomy: Part 2",
    description: "Capsule, nerves, parathyroids, lymphatics & more",
    icon: "❤️",
    customImage: "module-thyroid-anatomy.png",
    gradient: "from-violet-400 via-indigo-50 to-purple-300 border-violet-500",
  },
  {
    id: "histology",
    title: "Thyroid Histology",
    description: "Microscopic structure of the thyroid gland",
    icon: "🔬",
    customImage: "module-thyroid-histology.png",
    gradient: "from-violet-400 via-indigo-50 to-purple-300 border-violet-500",
  },
  {
    id: "physiology",
    title: "Thyroid Physiology",
    description: "Hormone synthesis and regulation",
    icon: "⚡",
    gradient: "from-violet-400 via-indigo-50 to-purple-300 border-violet-500",
  },
  {
    id: "disease",
    title: "Thyroid Diseases: Part 1",
    description: "Graves' orbitopathy, Hashimoto's, thyroiditis, thyroid storm, myxoedema coma",
    icon: "🩺",
    gradient: "from-violet-400 via-pink-50 to-rose-200 border-rose-400",
  },
  {
    id: "disease2",
    title: "Thyroid Diseases: Part 2",
    description: "Thyroid nodules, PTC, FTC, MTC, anaplastic carcinoma, MEN syndromes",
    icon: "🩺",
    gradient: "from-violet-400 via-pink-50 to-rose-200 border-rose-400",
  },
  {
    id: "pharmacology",
    title: "Thyroid Pharmacology",
    description: "Thionamides, radioactive iodine, levothyroxine, drug-induced thyroid disease & targeted therapies",
    icon: "💊",
    gradient: "from-emerald-400 via-teal-50 to-cyan-200 border-teal-400",
  },
  {
    id: "surgery",
    title: "Thyroid Surgery: Part 1",
    description: "Indications, types of thyroidectomy, pre-operative preparation & nerve anatomy",
    icon: "🏥",
    gradient: "from-sky-400 via-blue-50 to-indigo-200 border-blue-400",
  },
  {
    id: "surgery2",
    title: "Thyroid Surgery: Part 2",
    description: "Parathyroid risk, post-operative complications, RAI after surgery & long-term cancer follow-up",
    icon: "🏥",
    gradient: "from-sky-400 via-blue-50 to-indigo-200 border-blue-400",
  },
];
